import { configureStore } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import { combineReducers } from 'redux';
import { persistReducer, persistStore } from 'redux-persist';
import thunk from 'redux-thunk';
import userReducer from './auth/userSlice';
import calendarScheduleReducer from './calendar/calendarScheduleSlice';
import calendarBookedDatesReducer from './calendar/calendarBookedDatesSlice';
import calendarUnavailabilitiesReducer from './calendar/calendarUnavailabilitiesSlice';
import calendarSettingsReducer from './calendar/calendarSettingsSlice';
import fileUploadReducer from './storage/fileUploadSlice';
import profileFormReducer from './profiles/profileSlice';
import jobReducer from './jobs/jobSlice';
import ordersReducer from './orders/orderSlice';
import contactReducer from './chat/contactSlice';
import messageReducer from './chat/messageSlice';
import notificationReducer from './notifications/notificationSlice';
import adminContactReducer from './chat/adminContactSlice';
import favoriteReducer from './favorites/favoriteSlice';

const reducers = combineReducers({
  user: userReducer,
  schedule: calendarScheduleReducer,
  bookedDates: calendarBookedDatesReducer,
  unavailabilities: calendarUnavailabilitiesReducer,
  setting: calendarSettingsReducer,
  upload: fileUploadReducer,
  profile: profileFormReducer,
  jobs: jobReducer,
  order: ordersReducer,
  chat: contactReducer,
  message: messageReducer,
  notification: notificationReducer,
  favorites: favoriteReducer,
  admincontact: adminContactReducer
});

const persistConfig = {
  key: 'root',
  storage,
  blacklist: ['message', 'chat', 'order', 'notification', 'favorites', 'admincontact', 'bookedDates', 'unavailabilities', 'upload', 'jobs']
};

const persistedReducer = persistReducer(persistConfig, reducers);

const store = configureStore({
  reducer: persistedReducer, // Combine reducers with persistence
  devTools: process.env.NODE_ENV !== 'production', // Enable Redux DevTools only in development
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).concat(thunk) // Add thunk
});

export const persistor = persistStore(store);
export default store;
